import React from "react";
import { createRoot } from "react-dom/client";
import EnsureContactDetailsAndStartConversation from "../features/new-message/ensure-contact-details-and-start-conversation";

export default class NewConversationWebComponent extends HTMLElement {
	root = createRoot(this);

	connectedCallback() {
		this.render();
	}

	render() {
		const customer = this.getCustomerFromAttributes();
		this.root.render(
			<EnsureContactDetailsAndStartConversation customer={customer} />,
		);
	}

	getCustomerFromAttributes() {
		const tokenKey = this.getAttribute("token-key");
		const token = tokenKey ? window.sessionStorage.getItem(tokenKey) : null;
		const baseUrl = this.getAttribute("secure-messaging-proxy-base-url");
		const waypointBffRoutes = this.getAttribute(
			"waypoint-customer-proxy-base-urls",
		);
		const cultureCode = this.getAttribute("culture-code");
		const personId = this.getAttribute("person-id");
		const isInternalUserAttribute = this.getAttribute("is-internal-user");
		const category = this.getAttribute("category");
		const name = this.getAttribute("customer-name");
		return {
			token,
			tokenKey,
			baseUrl,
			waypointBffRoutes,
			isInternalUser:
				isInternalUserAttribute !== null &&
				isInternalUserAttribute.toLowerCase() === "true",
			personId,
			cultureCode,
			category,
			name,
		};
	}
}
